export const GET_ALL_QUESTION_CATEGORIES = 'GET_ALL_QUESTION_CATEGORIES'
export const ADD_QUESTION = 'ADD_QUESTION'
export const GET_ALL_QUESTIONS = 'GET_ALL_QUESTIONS'
export const GET_QUESTION_SINGLE = 'GET_QUESTION_SINGLE'
export const UPDATE_QUESTION = 'UPDATE_QUESTION'
